import React, { lazy } from 'react'
import { ServiceWrapper } from './ServiceWrapper'
import { ServiceType } from '../types'

// Lazy load individual service applications
const HRTemplatesApp = lazy(() =>
  Promise.resolve({
    default: () => (
      <div className="p-8 text-center">
        <h2 className="text-xl font-semibold mb-4">HR Templates Service</h2>
        <p className="text-gray-600">This service is currently being integrated.</p>
      </div>
    ),
  })
)

const ComplianceRecallApp = lazy(() =>
  Promise.resolve({
    default: () => (
      <div className="p-8 text-center">
        <h2 className="text-xl font-semibold mb-4">Compliance Recall Insurance Service</h2>
        <p className="text-gray-600">This service is currently being integrated.</p>
      </div>
    ),
  })
)

const RareEarthPermitApp = lazy(() =>
  Promise.resolve({
    default: () => (
      <div className="p-8 text-center">
        <h2 className="text-xl font-semibold mb-4">Rare Earth Permit Service</h2>
        <p className="text-gray-600">This service is currently being integrated.</p>
      </div>
    ),
  })
)

const RaidToRevenueApp = lazy(() =>
  Promise.resolve({
    default: () => (
      <div className="p-8 text-center">
        <h2 className="text-xl font-semibold mb-4">Raid to Revenue Service</h2>
        <p className="text-gray-600">This service is currently being integrated.</p>
      </div>
    ),
  })
)

const FiveGRecommerceApp = lazy(() =>
  Promise.resolve({
    default: () => (
      <div className="p-8 text-center">
        <h2 className="text-xl font-semibold mb-4">5G Recommerce Service</h2>
        <p className="text-gray-600">This service is currently being integrated.</p>
      </div>
    ),
  })
)

const VerpackGLoschungApp = lazy(() =>
  Promise.resolve({
    default: () => (
      <div className="p-8 text-center">
        <h2 className="text-xl font-semibold mb-4">VerpackG Löschung Service</h2>
        <p className="text-gray-600">This service is currently being integrated.</p>
      </div>
    ),
  })
)

// Wrapped service components
export const HRTemplatesService: React.FC = () => (
  <ServiceWrapper serviceType={ServiceType.HR} serviceName="HR Templates">
    <HRTemplatesApp />
  </ServiceWrapper>
)

export const ComplianceRecallService: React.FC = () => (
  <ServiceWrapper serviceType={ServiceType.COMPLIANCE} serviceName="Compliance Recall Insurance">
    <ComplianceRecallApp />
  </ServiceWrapper>
)

export const RareEarthPermitService: React.FC = () => (
  <ServiceWrapper serviceType={ServiceType.RARE_EARTH_PERMIT} serviceName="Rare Earth Permit">
    <RareEarthPermitApp />
  </ServiceWrapper>
)

export const RaidToRevenueService: React.FC = () => (
  <ServiceWrapper serviceType={ServiceType.TRADE} serviceName="Raid to Revenue">
    <RaidToRevenueApp />
  </ServiceWrapper>
)

export const FiveGRecommerceService: React.FC = () => (
  <ServiceWrapper serviceType={ServiceType.INTELLIGENCE} serviceName="5G Recommerce">
    <FiveGRecommerceApp />
  </ServiceWrapper>
)

export const VerpackGLoschungService: React.FC = () => (
  <ServiceWrapper serviceType={ServiceType.VERPACKG} serviceName="VerpackG Löschung">
    <VerpackGLoschungApp />
  </ServiceWrapper>
)
